import React, { useEffect, useState } from "react";
import { Group, Shape } from "react-konva/lib/ReactKonvaCore";
import { CANVAS_TOOL } from "../constants";

export default function LineCanvas({
    uuid, line, canvasStyle, handlerDeleteLine
}) {
    const [ points, setPoints ] = useState(new Array());
    const [ canvasTool, setCanvasTool ] = useState(null);
    const [ strokeWidth, setStrokeWidth ] = useState(0);
    const [ ratio , setRatio ] = useState(1);

    useEffect(() => {
        if (line) {
            setPoints(line.points);
            setCanvasTool(line.canvasTool);
        } else {
            setPoints(new Array());
            setCanvasTool(null);           
        }
    }, [line]);

    useEffect(() => {
        if (canvasTool) {
            const ratio = canvasStyle.width / canvasTool.width || 1;
            const lineThickness = canvasTool.thickness / ratio / window.devicePixelRatio;
            
            setStrokeWidth(lineThickness);
            setRatio(ratio);
        } else {
            setStrokeWidth(0);
            setRatio(1);
        }
    }, [canvasStyle, canvasTool]);

    const onDeleteLine = () => {
        if (handlerDeleteLine && canvasTool.tool === CANVAS_TOOL.pen) handlerDeleteLine(uuid);
    }
    
    return (
        <Group scaleX={ratio} scaleY={ratio}>
            <Shape 
                onMouseOver={onDeleteLine}
                onTouchMove={onDeleteLine}
                hitStrokeWidth={strokeWidth === Infinity ? "auto" : strokeWidth}
                sceneFunc={(context, shape) => {
                    if (!canvasTool || !points) return;

                    context.globalCompositeOperation = canvasTool.tool === "pen" ? "source-over" : "destination-out";
                    context.fillStyle = canvasTool.color;
                    context.strokeStyle = canvasTool.color;
                    context.lineWidth = canvasTool.tool === "pen" ? strokeWidth : strokeWidth * 5;
                    context.globalAlpha = canvasTool.tool === "pen" ? canvasTool.opacity : 1;
                    context.lineCap = "round";
                    
                    context.beginPath();        
                    
                    if (points.length < 3) {
                        if (points[0]) {
                            context.arc(points[0], points[1], 10); 
                            context.fill();
                            context.fillStrokeShape(shape);
                            context.closePath(); 
                        }
                        return;
                    }
                    context.moveTo(points[0], points[1]);    
                
                    for (var i = 2; i < points.length - 3; i=i+2) {
                        var c = (points[i] + points[i + 2]) / 2;
                        var d = (points[i + 1] + points[i + 3]) / 2;
                            
                        context.quadraticCurveTo(points[i], points[i+1], c, d);
                    }
                    
                    context.quadraticCurveTo(
                        points[i],
                        points[i + 1],
                        points[i + 2],
                        points[i + 3]
                    );    
                    context.stroke(); 
                    context.closePath(); 
                }}
                hitFunc={(context, shape) => {
                    if (!canvasTool || !points) return;
                    if (canvasTool.tool !== "pen") return;
                    context.beginPath();
                    context.lineWidth = strokeWidth * 2;
                    if (points.length < 3) {
                        if (points[0]) {
                            context.arc(points[0], points[1], strokeWidth * 5, 0, Math.PI * 2, !0);
                            context.fill();
                            context.fillStrokeShape(shape);
                            context.closePath(); 
                        }
                        return;
                    }

                    context.moveTo(points[0], points[1]);
                    for (var i = 2; i < points.length - 3; i=i+2) {
                        var c = (points[i] + points[i + 2]) / 2;
                        var d = (points[i + 1] + points[i + 3]) / 2;
                            
                        context.quadraticCurveTo(points[i], points[i+1], c, d);
                    }
                    context.quadraticCurveTo(
                        points[i],
                        points[i + 1],
                        points[i + 2],
                        points[i + 3]
                    );    
                    context.stroke(); 
                    context.fillStrokeShape(shape);
                }}      
            />
        </Group>
    )
}